import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import type { NewsItem } from "@/mocks/news";

interface LatestNewsProps {
  news: NewsItem[];
}

export default function LatestNews({ news }: LatestNewsProps) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 lg:px-10">
      <SectionTitle
        eyebrow="影视资讯"
        title="最新午夜影视资讯"
        description="影评、专题、访谈与行业新闻，帮你在选片之前先了解这个夜晚正在发生什么。"
        actionLabel="查看全部资讯"
        actionTo="/news"
      />
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <ul className="lg:col-span-2">
          {news.map((item) => (
            <li key={item.id} className="border-b border-background-200/80 last:border-b-0">
              <Link
                to={`/news/${item.id}`}
                className="group flex items-start gap-4 py-4 transition-colors"
              >
                <span className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-200/70 text-xs font-bold text-primary-400">
                  {item.category}
                </span>
                <div className="min-w-0">
                  <h3 className="mb-1 line-clamp-1 font-heading text-[15px] font-semibold text-foreground-100 transition-colors group-hover:text-primary-400">
                    {item.title}
                  </h3>
                  <p className="line-clamp-1 text-xs text-foreground-600">
                    {item.date} · {item.source}
                  </p>
                </div>
                <i className="ri-arrow-right-line ml-auto hidden shrink-0 self-center text-foreground-600 transition-colors group-hover:text-primary-400 sm:block"></i>
              </Link>
            </li>
          ))}
        </ul>

        <aside className="rounded-lg border border-background-200/80 bg-background-100 p-6">
          <h3 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-50">
            <i className="ri-moon-foggy-line text-primary-400"></i>
            午夜观影小贴士
          </h3>
          <ul className="space-y-4">
            {[
              "关掉主光源，让屏幕成为房间最亮的地方。",
              "音量比白天低两三格，保留弱音效的层次。",
              "按当前情绪选片，比按类型选片更容易满意。",
              "睡前两小时结束观影，留一点余味给自己。",
            ].map((tip) => (
              <li key={tip} className="flex gap-3 text-sm leading-relaxed text-foreground-500">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500"></i>
                {tip}
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </section>
  );
}